<!-- H5关联审图要点 -->
<template lang="pug">
van-popup(v-model="popupShow" position="bottom" closeable :overlay="false")
  .associatePoint
    .titleRow 审图要点
    .content
      van-search(v-model="keyword" placeholder="请输入关键字" show-action @search="onSearch")
        template(#action)
          div(@click="openContents") 目录
      //- 面包屑
      ul.breadcrumb
        li(v-for="(item, index) in navList" :key="index" :class="{ 'navActive': item.id === currentFolderId }" @click="clickBread(item, index)") {{ item.cnName }}
          span(v-if="index !== navList.length - 1" style="padding: 0px 6px") /
      //- 列表
      van-pull-refresh.folderList(v-model="refreshing" v-loading="loading" @refresh="onRefresh")
        .folderItem(v-for="item in pointList" :key="item.folderId" :class="{ 'folderActive': item.id === checkedPoint.id }" @click="nextDetails(item)")
          van-image.leftIcon(fit="contain" :src="logoSrc(item)" @click.stop="select(item)")
          .folder_name {{ item.cnName }}
        .empty(v-if="!pointList.length") {{ currentFolderId ? '暂无数据' : '请选择审图目录' }} 
      .buttons
        van-button.button(type="info" round plain @click="popupShow = false") 取消
        van-button.button(type="info" round @click="submit") 确定
  //- 审图目录弹框
  van-popup(v-model="contentsShow" round position="right")
    .contentsArea
      van-cascader(:title="`审图目录：${curContent.cnName || ''}`" :options="contents" :field-names="fieldNames" :closeable="false" @change="changeContent")
</template>

<script>
import { mapState } from "vuex";
import { throttle } from "@/CommonDP/utils/throttle.js"; // 函数节流
import { tableRowIcon } from "@/CommonDP/utils/docPublic";
import pointsService from "@/CommonDP/service/planApprovalPoints-service";

export default {
  components: {},
  data() {
    return {
      popupShow: false,
      contentsShow: false,
      contents: [], // 目录列表
      curContent: {}, // 当前目录
      fieldNames: {
        text: "cnName",
        value: "id",
        children: "list"
      },
      keyword: "",
      navList: [], // 展开路径
      currentFolderId: "", // 当前打开的文件夹id
      pointList: [],
      checkedPoint: {}, // 选中的审图要点
      refreshing: false,
      loading: false
    };
  },
  computed: {
    ...mapState({
      enterpriseId: (state) => state.enterprise.enterpriseId
    })
  },
  watch: {
    // 切换审图目录
    curContent(val) {
      if (val && val.id) {
        this.toRefresh();
      }
    }
  },
  mounted() {},
  methods: {
    // logo图片地址
    logoSrc(item) {
      let params = { ...item };
      if (params.list && params.list.length) params = { ...params, isFolder: 1 };
      return tableRowIcon(params);
    },
    // 初始化
    init() {
      this.reset();
      this.getContents();
    },
    // 获得目录数据
    async getContents() {
      const enterpriseId = this.enterpriseId;
      const { data } = await pointsService.queryTemplate(enterpriseId, "", "0");
      this.contents = data || [];
    },
    // 获得审图要点
    async getPointList(id) {
      this.loading = true;
      try {
        const { data } = await pointsService.queryTemplate(id, this.keyword, "0");
        this.pointList = data || [];
        this.currentFolderId = id;
        this.checkedPoint = {};
      } finally {
        this.loading = false;
      }
    },

    // 查询
    onSearch() {
      this.toRefresh();
    },
    // 刷新列表
    toRefresh() {
      this.navList = [];
      this.navList.push(this.curContent);
      let { id } = this.curContent || {};
      this.getPointList(id);
    },
    // 点击路径
    clickBread(item, index) {
      if (index === 0) {
        this.toRefresh();
      } else {
        this.navList = this.navList.slice(0, index + 1);
        this.pointList = item.list || [];
        this.currentFolderId = item.id || "";
        this.checkedPoint = {};
      }
    },
    // 下拉刷新
    async onRefresh() {
      try {
        this.toRefresh();
      } finally {
        this.refreshing = false;
      }
    },
    // 点击文件夹，进入下一级
    nextDetails: throttle(function (item) {
      if (item.list && item.list.length) {
        this.navList.push(item);
        this.pointList = item.list || [];
        this.currentFolderId = item.id || "";
        this.checkedPoint = {};
      } else {
        this.select(item);
      }
    }, 200),
    // 选中
    select(item) {
      if (item.id === this.checkedPoint.id) this.checkedPoint = {};
      else this.checkedPoint = item;
    },

    // 打开目录弹框
    openContents() {
      this.contentsShow = true;
    },
    // 设置当前目录
    changeContent({ selectedOptions }) {
      if (selectedOptions && selectedOptions.length) {
        let lastOption = selectedOptions[selectedOptions.length - 1] || {};
        this.curContent = lastOption;
      } else {
        this.curContent = {};
      }
    },

    // 确定
    submit() {
      this.$emit("callback", this.checkedPoint || {});
      this.popupShow = false;
    },
    // 重置
    reset() {
      this.navList = [];
      this.keyword = "";
      this.curContent = {};
      this.currentFolderId = "";
      this.pointList = [];
      this.checkedPoint = {};
    }
  }
};
</script>

<style lang="scss" scoped>
.associatePoint {
  width: 100vw;
  height: 100vh;
  position: relative;
  .titleRow {
    height: 46px;
    padding: 0 10px;
    line-height: 46px;
    border-bottom: 1px solid #f5f6fa;
    text-align: center;
  }
  .content {
    height: calc(100% - 46px);
    padding-top: 5px;
    background-color: #f5f6fa;
    display: flex;
    flex-direction: column;
    .buttons {
      padding: 2vh 0;
      background-color: #fff;
      text-align: center;
      .button {
        width: 200px;
        height: 40px;
        margin: 0 4vw;
        max-width: 42vw;
      }
    }
  }
}

.breadcrumb {
  width: 100%;
  height: 32px;
  line-height: 32px;
  padding: 0 16px;
  white-space: nowrap;
  background-color: #ffffff;
  border-bottom: 1px solid #e5e8f1;
  overflow: auto;

  li {
    list-style: none;
    display: inline-block;
    color: var(--theme-color, #4777e7);
    font-size: 14px;
  }
  .navActive {
    color: #323232;
  }
}

.folderList {
  width: 100%;
  height: 1px;
  flex-grow: 1;
  overflow-y: auto;
  .empty {
    width: 100%;
    height: calc(100% - 66px);
    display: flex;
    align-items: center;
    justify-content: center;
    color: #999999;
    font-size: 16px;
  }
}

.folderItem {
  width: 100%;
  height: 70px;
  padding: 0 3vw;
  box-sizing: border-box;
  background-color: #ffffff;
  border-bottom: 1px solid #e5e8f1;
  display: flex;
  align-items: center;

  .leftIcon {
    width: 42px;
    height: 42px;
    padding: 5px;
    margin-bottom: 2px;
  }

  .folder_name {
    width: calc(100% - 75px);
    height: 50px;
    overflow-x: overlay !important;
    overflow-x: auto;
    font-size: 16px;
    line-height: 50px;
    color: #323232;
    white-space: nowrap;
  }
}
.folderActive {
  background-color: #7fc65c;
  .folder_name {
    color: #fff !important;
  }
}

.contentsArea {
  width: 320px;
  max-width: 80vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
}
::v-deep .van-cascader {
  .van-cascader__header {
    height: 10vh;
    .van-cascader__title {
      margin: 2vh 0 0;
      display: -webkit-box; /* Safari, Chrome, Opera */
      -webkit-box-orient: vertical; /* Safari, Chrome, Opera */
      -webkit-line-clamp: 2; /* Safari, Chrome, Opera */
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .van-cascader__options {
    height: calc(100vh - 10vh - 64px);
  }
}
</style>
